import { logError } from "util/logging";
// Here, we're telling TypeScript that s.router.route is NOT nullable
// even though it is. This is okay because we know that `selectRoute` is
// only called after the application has been loaded and there is a route in state.
export const selectRoute = (s) => {
    if (!s.router.route) {
        logError(new Error("selectRoute was called and there is no route in state"));
    }
    return s.router.route;
};
export const selectCurrentRouteClusterId = (s) => selectRoute(s).params.clusterId;
